/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./indexFaceScan.vue?vue&type=template&id=3c9fea3e&scoped=true"
import script from "./indexFaceScan.vue?vue&type=script&lang=js"
export * from "./indexFaceScan.vue?vue&type=script&lang=js"
import style0 from "./indexFaceScan.vue?vue&type=style&index=0&id=3c9fea3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9fea3e",
  null
  
)

export default component.exports